"use client";
import { buttonVariants } from "@/components/ui/button";
import { cookieName } from "@/i18n/settings";
import Link from "next/link";
import { useCookies } from "react-cookie";

export default function NotFoundPage() {
  const [cookies] = useCookies([cookieName]);

  return (
    <html>
      <body className="h-dvh">
        <div className="flex h-full flex-col items-center justify-center gap-6">
          <p>404 | the page you are looking for is not found</p>
          <Link
            href={`/${cookies?.i18next ?? "en"}`}
            className={buttonVariants({
              variant: "outline",
              className: "border-secondary/40",
            })}
          >
            Home
          </Link>
        </div>
      </body>
    </html>
  );
}
